import pluralize from 'pluralize'
import { HttpClient } from '@opallabs/api'
import { enqueueDelayedEntityResponse } from '../../jsonApiDeserializer/responseEntityQueues'
import { jsonApiWrapper } from '../../jsonApiParser'
import { loadJsonApiEntities } from '../loadJsonApiEntities'
import updateJsonApiEntity from '../updateJsonApiEntity'

const putBudget = ({ id, context, value }) =>
  HttpClient().put(`/budgets/${pluralize.plural(context)}/${id}`, value)

const updateBudget = (options) => (dispatch, getState) => {
  if (options.updateJsonApiEntity) {
    dispatch(
      updateJsonApiEntity({
        type: 'budget',
        id: options.id,
        attributes: options.value.budget,
      })
    )
  }

  return putBudget(options)
    .then((response) => {
      const body = response.data
      if (body.data) {
        if (options.delayServerApplication) {
          enqueueDelayedEntityResponse({
            type: 'budget',
            id: options.id,
            data: body,
          })
          return null
        }
        dispatch(loadJsonApiEntities(body))
        jsonApiWrapper({
          data: getState().jsonApiEntities.budget[body.data.id],
          state: getState(),
        })
      }
      if (options.callback) {
        options.callback()
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })
}

export default updateBudget
